import { type NotificationTemplateSource, OfferNotificationTemplateChannel } from '@today/types'

/** One row of the template library (TO-140 offer-notification-templates REQ-011). */
export interface NotificationTemplateRowView {
	id: string
	name: string
	channelType: OfferNotificationTemplateChannel
	locale: string
	isActive: boolean
	isDefaultForChannel: boolean
	source: NotificationTemplateSource
}

/**
 * The create/edit form's values, as typed. `description` and `subject` are
 * strings here; the caller maps blank to null when it saves.
 */
export interface NotificationTemplateDraft {
	name: string
	description: string
	channelType: OfferNotificationTemplateChannel
	locale: string
	subject: string
	body: string
	isDefaultForChannel: boolean
	isActive: boolean
}

/** A rendered message: the subject (EMAIL only, else null) and the body. */
export interface MessagePreviewView {
	subject: string | null
	body: string
}

/** One option of a picker: its value and its visible label. */
export interface MessagePickerOption {
	value: string
	label: string
}

/** The default display name of each template channel type; override per view through `channelLabels`. */
export const DEFAULT_TEMPLATE_CHANNEL_LABELS: Readonly<Record<OfferNotificationTemplateChannel, string>> = {
	[OfferNotificationTemplateChannel.EMAIL]: 'Email',
	[OfferNotificationTemplateChannel.SMS]: 'SMS',
	[OfferNotificationTemplateChannel.WHATSAPP]: 'WhatsApp',
	[OfferNotificationTemplateChannel.ALL]: 'All channels',
}
